import { reportRoutes } from '@routes'

type ReportsList = {
  category: string
  reports: {
    description: any; title: string; path: string
}[]
}[]

/**
 * Same grouping as getReportsList, with the descriptions the menu panel shows.
 * Both must filter identically: ReportsMenuPanel indexes into this list with the
 * category index the navigation list produced.
 */
export function getReportsMenuList(isKia: boolean): ReportsList {
  let reportMap = {}
  for (const route of reportRoutes) {
    if (route.enterpriseOnly === 'kia' && !isKia) {
      continue
    }

    if (!reportMap[route.category]) {
      reportMap[route.category] = {
        category: route.category,
        reports: [],
      }
    }
    reportMap[route.category].reports.push(route)
  }

  const reportList: ReportsList = Object.keys(reportMap).map(key => reportMap[key])
  return reportList
}
